import * as Sentry from '@sentry/react'
import { env } from '@/env'

/**
 * Boots Sentry once, before React renders. The `enabled` flag gates on DSN
 * presence so dev/test environments (DSN empty) pay no runtime cost.
 * Release/tracing integrations land in Phase 6/7.
 */
export function initSentry() {
  Sentry.init({
    dsn: env.VITE_SENTRY_DSN,
    environment: env.VITE_APP_ENV,
    enabled: !!env.VITE_SENTRY_DSN,
  })
}
